export default class ProjectDocumentCategory {
  attachEvent() {
    const toggle = (select, isUserAction = false) => {
      const wrapper = select.closest('.nested-fields') || select.closest('.form-group');
      if (!wrapper) return;
      const customDiv = wrapper.querySelector('.project-document-custom-category-wrapper');
      const customInput = wrapper.querySelector('.project-document-custom-category');
      
      if (customDiv && customInput) {
        const show = select.value === 'その他';
        if (show) {
          customDiv.classList.remove('d-none');
        } else {
          customDiv.classList.add('d-none');
        }
        customInput.required = show;
        if (!show || isUserAction) customInput.value = '';
      }
    };
    
    // 初期設定
    document.querySelectorAll('.project-document-category-select').forEach(select => toggle(select));
    
    // 変更監視
    document.addEventListener('change', event => {
      if (event.target.matches('.project-document-category-select')) {
        toggle(event.target, true);
      }
    });
    
    // Cocoon対応
    document.addEventListener('cocoon:after-insert', event => {
      const select = event.detail.insertedItem?.querySelector('.project-document-category-select');
      if (select) toggle(select);
    });
  }
}
